import React from "react";
import { Grid, Fab, Typography } from "@material-ui/core";
import { Redirect, Route, Switch } from "react-router-dom";
import MessageIcon from "@material-ui/icons/Message";
import BasePage from "./BasePage";
import MenuLateral from "./MenuLateralNovo";
import PrivateRoute from "./SomaStandard/AuthComponents/PrivateRoute";

const FullPage = (props) => {

  return (
    <BasePage>
      <Grid container style={{ height: "100%", flexWrap: "nowrap" }} alignItems={"stretch"}>
        <MenuLateral />
        <Grid style={{ width: "100%", overflow: "auto", height: "100%" }}>
          <Grid style={{ minWidth: "300px" }}>
            <Switch>
              <Route exact path={props.parentUrl} component={props.parentComponent} key={0} />
              {props.routes
                .filter((r) => !r.link)
                .map((r, i) => (
                  <PrivateRoute
                    path={`${props.parentUrl}/${r.route}`}
                    key={`priv-route-${i}`}
                    to={r.show}
                    redirect={props.parentUrl}
                    hideToRepre={r.hideToRepre}
                  >
                    <Grid
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      style={{ paddingTop: "20px", paddingBottom: "20px" }}
                    >
                      <Grid item xs="auto" style={{ backgroundColor: "rgba(198, 164, 137, 0.18)", padding: "1%" }}>
                        <Grid container direction="column" justify="center" alignItems="center">
                          <Typography noWrap style={{ color: "#707070", fontSize: "32px", fontFamily: "flama-medium" }}>
                            {r.text}
                          </Typography>
                          <Grid style={{ width: "70%", outline: "1px solid #C6A489", color: "#C6A489" }}></Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <r.component {...r.props} />
                  </PrivateRoute>
                ))}
              <Route>
                <Redirect to={props.parentUrl} />
              </Route>
            </Switch>
            <div style={{ height: "75px" }}></div>
            <Fab
              color="primary"
              style={{ top: "auto", right: 20, bottom: 20, left: "auto", position: "fixed" }}
              href="http://chamados.somagrupo.com.br/"
              target="_blank"
            >
              <MessageIcon />
            </Fab>
          </Grid>
        </Grid>
      </Grid>
    </BasePage>
  );
};

export default FullPage;
